<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-1 text-primary">
        <b>Job Vacancy</b>
      </h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5>
        <b>Edit Job Vacancy</b>
      </h5>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Job Type" label-for="input-1">
            <b-form-select v-model="items.job_type.code" class="mb-3">
              <template slot="first">
                <option :value="null" disabled>Select Job Type</option>
                <option v-for="data in job_type" :key="data" :value="data.id">{{data.name}}</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Job Name" label-for="input-1">
            <b-form-input v-model="items.job_name" placeholder="Job Name"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Department" label-for="input-1">
            <b-form-input v-model="items.department" placeholder="Department"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Location" label-for="input-1">
            <b-form-input v-model="items.location" placeholder="Location"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Experience" label-for="input-1">
            <b-form-select v-model="items.job_experience.code" class="mb-3">
              <template slot="first">
                <option :value="null" disabled>Select Experience</option>
                <option v-for="data in job_experience" :key="data" :value="data.id">{{data.name}}</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Description (Bahasa)" label-for="input-1">
            <b-form-textarea
              id="textarea"
              v-model="items.description.id"
              placeholder="Description In Bahasa"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Description (English)" label-for="input-1">
            <b-form-textarea
              id="textarea"
              v-model="items.description.en"
              placeholder="Description In English"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Requirements (Bahasa)" label-for="input-1">
            <b-form-textarea
              id="textarea"
              v-model="items.requirement.id"
              placeholder="Requirements In Bahasa"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Requirements (English)" label-for="input-1">
            <b-form-textarea
              id="textarea"
              v-model="items.requirement.en"
              placeholder="Requirements In English"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Skills (Bahasa)" label-for="input-1">
            <b-form-input
              v-model="items.skill.id"
              placeholder="Use semicolon to separate tags e.g.: Teamwork; Leadership"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Skills (English)" label-for="input-1">
            <b-form-input
              v-model="items.skill.en"
              placeholder="Use semicolon to separate tags e.g.: Teamwork; Leadership"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="form-group" v-for="(input , k) in items.stages" :key="k">
        <b-row>
          <b-col md="3">
            <b-form-group id="fieldset-1" label-class="mb-0" label-for="input-1">Stage Test {{k+1}}</b-form-group>
          </b-col>
          <b-col md="3" class="text-right">
            <b-link
              style="text-decoration: none;"
              class="text-danger"
              @click="remove(k)"
              v-show="k || ( !k && items.stages.length > 1)"
            >Remove</b-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-select v-model="input.code" class="mb-3">
              <template slot="first">
                <option :value="null" disabled>Select Test</option>
                <option v-for="data in onlinetest" :key="data" :value="data.id">{{data.test_name}}</option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-button
              block
              variant="outline-primary"
              @click="add(k)"
              v-show="k == items.stages.length-1"
            >
              <i class="fas fa-plus"></i> Add More
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group v-model="items.status" :options="options2" name="radio-inline"></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br />

      <b-form-group id="fieldset-1" label="Period" label-for="input-1"></b-form-group>
      <b-row>
        <b-col md="3">
          <b-row class="m-0">
            <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
              <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
            </b-col>
            <b-col class="px-0">
              <datepicker
                input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                placeholder="Start Date"
                v-model="items.periode.start_date"
                :format="customFormatter"
                :disabledDates="disabledDates"
              ></datepicker>
            </b-col>
            <b-col align="left" md="1" class="px-0">
              <b-col
                align="left"
                class="pt-1 px-4 form-control del-calender-select border-left-0"
                md="2"
              >
                <b-row align="left" class="pt-1">
                  <b-col>
                    <b-link @click="resetStardate" style="text-decoration:none">
                      <i class="text-danger fas fa-times"></i>
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row class="m-0">
            <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
              <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
            </b-col>
            <b-col class="px-0">
              <datepicker
                input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                placeholder="End Date"
                v-model="items.periode.end_date"
                :format="customFormatter"
                :disabledDates="disabledDates"
              ></datepicker>
            </b-col>
            <b-col align="left" md="1" class="px-0">
              <b-col
                align="left"
                class="pt-1 px-4 form-control del-calender-select border-left-0"
                md="2"
              >
                <b-row align="left" class="pt-1">
                  <b-col>
                    <b-link @click="resetEnddate" style="text-decoration:none">
                      <i class="text-danger fas fa-times"></i>
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-right">
          <b-button variant="primary" @click="put()" size="lg" class="mr-3">Save</b-button>
          <router-link :to="{name: 'pxJobVacancy'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
      <br />
    </b-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      options2: [
        { text: 'Publish', value: 'publish' },
        { text: 'Archive', value: 'archive' },
      ],
      items: [],
      job_type_selected: null,
      job_name: null,
      departement: null,
      location: null,
      job_experience_selected: null,
      description_id: null,
      description_en: null,
      requirement_id: null,
      requirement_en: null,
      skill_id: null,
      skill_en: null,
      job_type: [],
      job_experience: [],
      onlinetest: [],
      period_start: '',
      period_end: '',
      status: null,
      test: [
        {
          id_test: null,
        },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },
  beforeCreate() {
    this.$store.dispatch(
      'jobVacancyModule/getJobvacancyid',
      this.$route.params.id,
    );
    this.$store.dispatch('jobVacancyModule/getJobtype', { root: true });
    this.$store.dispatch('jobVacancyModule/getJobexperience', { root: true });
    this.$store.dispatch('onlineTestModule/getOnlineTest', { root: true });
  },
  created() {
    this.$store.watch(
      state => state.jobVacancyModule.jobvacancy_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
    this.$store.watch(
      state => state.jobVacancyModule.jobtype,
      (newValue, oldValue) => {
        this.job_type = newValue;
        // Do whatever makes sense now
        if (this.job_type.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
    this.$store.watch(
      state => state.jobVacancyModule.jobexperience,
      (newValue, oldValue) => {
        this.job_experience = newValue;
        // Do whatever makes sense now
        if (this.job_experience.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
    this.$store.watch(
      state => state.onlineTestModule.onlinetest,
      (newValue, oldValue) => {
        this.onlinetest = newValue;
        // Do whatever makes sense now
        if (this.onlinetest.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    resetStardate() {
      this.period_start = '';
    },
    resetEnddate() {
      this.period_end = '';
    },
    add(index) {
      this.items.stages.push({ code: null, name: null });
    },
    remove(index) {
      this.items.stages.splice(index, 1);
    },
    put() {
      const formData = new FormData();

      formData.append('job_name', this.items.job_name);
      formData.append('job_type', this.items.job_type.code);
      formData.append('department', this.items.department);
      formData.append('location', this.items.location);
      formData.append('job_experience', this.items.job_experience.code);
      formData.append('description_id', this.items.description.id);
      formData.append('description_en', this.items.description.en);
      formData.append('requirement_id', this.items.requirement.id);
      formData.append('requirement_en', this.items.requirement.en);
      formData.append('skill_id', this.items.skill.id);
      formData.append('skill_en', this.items.skill.en);
      formData.append('status', this.items.status);
      if (
        this.items.periode.start_date != ''
        && this.items.periode.end_date == ''
      ) {
        const start = this.items.periode.start_date.toJSON().slice(0, 10);
        formData.append('period_start', start);
        formData.append('period_end', this.items.periode.end_date);
      }
      if (
        this.items.periode.end_date != ''
        && this.items.periode.start_date == ''
      ) {
        const end = this.items.periode.end_date.toJSON().slice(0, 10);
        formData.append('period_start', this.items.periode.start_date);
        formData.append('period_end', end);
      }
      if (this.period_start != '' && this.items.periode.end_date != '') {
        const start = this.items.periode.start_date.toJSON().slice(0, 10);
        const end = this.items.periode.end_date.toJSON().slice(0, 10);

        formData.append('period_start', start);
        formData.append('period_end', end);
      }
      if (
        this.items.periode.start_date == ''
        && this.items.periode.end_date == ''
      ) {
        formData.append('period_start', this.items.periode.start_date);
        formData.append('period_end', this.items.periode.end_date);
      }
      if (this.items.stages) {
        $.each(this.items.stages, (index, value) => {
          formData.append('stage', value.code);
        });
      } else {
        formData.append('stage', this.items.stages);
      }

      this.loading = true;
      this.$store
        .dispatch('jobVacancyModule/putJobvacancy', {
          id: this.$route.params.id,
          formData,
        })
        .then((response) => {
          this.loading = false;
          this.$router.push({ name: 'pxJobVacancy' });
          this.$swal({
            type: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(response);
        })
        .catch((error) => {
          this.loading = false;
          this.serverError = error.response.data;
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
  },
};
</script>

<style>
</style>
